"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _emotion = require("emotion");

var _groupBy = _interopRequireDefault(require("lodash/groupBy"));

var _maxBy = _interopRequireDefault(require("lodash/maxBy"));

var _Spinner = _interopRequireDefault(require("@cimpress/react-components/lib/shapes/Spinner"));

var _reactIntl = require("react-intl");

var _services = require("./services");

var _ListPriceInitiatorWizardModal = require("./ListPriceInitiatorWizardModal");

var _RadioSelector = _interopRequireDefault(require("../RadioSelector/RadioSelector"));

var _RadioSelectorButton = _interopRequireDefault(require("../RadioSelector/RadioSelectorButton"));

var _listPriceInitiatorMessages = require("./listPriceInitiatorMessages");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  margin-bottom: 12px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  justify-content: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var divStyle = (0, _emotion.css)(_templateObject());
var headerStyle = (0, _emotion.css)(_templateObject2());

var ListPriceInitiatorCreateOptionStep =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(ListPriceInitiatorCreateOptionStep, _PureComponent);

  function ListPriceInitiatorCreateOptionStep() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, ListPriceInitiatorCreateOptionStep);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(ListPriceInitiatorCreateOptionStep)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.toDate = function (dateStr) {
      return (0, _moment.default)(dateStr, 'YYYY-MM-DD').toDate();
    };

    return _this;
  }

  (0, _createClass2.default)(ListPriceInitiatorCreateOptionStep, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee() {
        var _this$props, lastAction, listPrices, nextStep, prevStep;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = this.props, lastAction = _this$props.lastAction, listPrices = _this$props.listPrices, nextStep = _this$props.nextStep, prevStep = _this$props.prevStep;

                if (!(listPrices === null)) {
                  _context.next = 6;
                  break;
                }

                _context.next = 4;
                return this.loadListPrices();

              case 4:
                _context.next = 7;
                break;

              case 6:
                if (listPrices.length === 0 && lastAction === _ListPriceInitiatorWizardModal.PREV) {
                  prevStep();
                } else if (listPrices.length === 0 && lastAction === _ListPriceInitiatorWizardModal.NEXT) {
                  nextStep();
                }

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "getAvailableListPriceContracts",
    value: function () {
      var _getAvailableListPriceContracts = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2() {
        var _this2 = this;

        var _this$props2, isProduction, merchantId, productFulfiller, onGetAccessToken, buyer, seller, now, terms, termGroups, mostRecentTerms;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$props2 = this.props, isProduction = _this$props2.isProduction, merchantId = _this$props2.merchantId, productFulfiller = _this$props2.productFulfiller, onGetAccessToken = _this$props2.onGetAccessToken;
                buyer = {
                  id: merchantId,
                  type: 'merchants'
                };
                seller = {
                  id: productFulfiller.id,
                  type: 'fulfillers'
                };
                now = (0, _moment.default)().toDate();
                _context2.next = 6;
                return (0, _services.searchTerms)(seller, buyer, onGetAccessToken, isProduction);

              case 6:
                terms = _context2.sent;
                termGroups = (0, _groupBy.default)(terms, 'termId');
                mostRecentTerms = Object.keys(termGroups).map(function (key) {
                  return (0, _maxBy.default)(termGroups[key], function (term) {
                    return term.revisionId;
                  });
                });
                return _context2.abrupt("return", mostRecentTerms.filter(function (term) {
                  return term.status !== 'terminated' && term.status !== 'rejected' && term.type === 'list' && _this2.toDate(term.effectiveStartDate) < now && _this2.toDate(term.effectiveEndDate) > now;
                }));

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getAvailableListPriceContracts() {
        return _getAvailableListPriceContracts.apply(this, arguments);
      }

      return getAvailableListPriceContracts;
    }()
  }, {
    key: "loadListPrices",
    value: function () {
      var _loadListPrices = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3() {
        var _this$props3, handleError, setAvailableListPriceContracts, setListPriceContractsStatus;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this$props3 = this.props, handleError = _this$props3.handleError, setAvailableListPriceContracts = _this$props3.setAvailableListPriceContracts, setListPriceContractsStatus = _this$props3.setListPriceContractsStatus;
                setListPriceContractsStatus(_ListPriceInitiatorWizardModal.LOADING);
                this.getAvailableListPriceContracts().then(function (listPrices) {
                  setAvailableListPriceContracts(listPrices);
                }).catch(function () {
                  setListPriceContractsStatus(_ListPriceInitiatorWizardModal.UNAVAILABLE);
                  handleError('Error Loading List Price Contracts');
                });

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function loadListPrices() {
        return _loadListPrices.apply(this, arguments);
      }

      return loadListPrices;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          createOption = _this$props4.createOption,
          fulfillerName = _this$props4.fulfillerName,
          onSelectCreateOption = _this$props4.onSelectCreateOption,
          status = _this$props4.status,
          formatMessage = _this$props4.intl.formatMessage;

      if (status === _ListPriceInitiatorWizardModal.LOADING) {
        return _react.default.createElement(_Spinner.default, null);
      }

      if (status === _ListPriceInitiatorWizardModal.UNAVAILABLE) {
        return null;
      }

      return _react.default.createElement("div", null, _react.default.createElement("h5", {
        className: headerStyle
      }, formatMessage(_listPriceInitiatorMessages.createOptionStep.header, {
        name: fulfillerName
      })), _react.default.createElement("div", {
        className: divStyle
      }, _react.default.createElement(_RadioSelector.default, {
        value: createOption,
        onClick: onSelectCreateOption,
        displayCheckmark: false
      }, _react.default.createElement(_RadioSelectorButton.default, {
        title: formatMessage(_listPriceInitiatorMessages.createOptionStep.updateExistingOptionButtonTitle),
        description: formatMessage(_listPriceInitiatorMessages.createOptionStep.updateExistingOptionButtonDescription, {
          name: fulfillerName
        }),
        value: _ListPriceInitiatorWizardModal.EXISTING
      }), _react.default.createElement(_RadioSelectorButton.default, {
        title: formatMessage(_listPriceInitiatorMessages.createOptionStep.newOptionButtonTitle),
        description: formatMessage(_listPriceInitiatorMessages.createOptionStep.newOptionButtonDescription, {
          name: fulfillerName
        }),
        value: _ListPriceInitiatorWizardModal.NEW
      }))));
    }
  }]);
  return ListPriceInitiatorCreateOptionStep;
}(_react.PureComponent);

var _default = (0, _reactIntl.injectIntl)(ListPriceInitiatorCreateOptionStep);

exports.default = _default;